export function urlMatchesLocation(url) {
  return window.location.href.includes(url) ? url : null;
}
